import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { selectProductLifeProtectPlus } from 'quick-quote/product-life-protect-plus/actions'
import { getSelectedProductLifeProtectPlus } from 'quick-quote/product-life-protect-plus/selectors'
import VALUES from 'core/data-model/constants/values'

export const ComboHealthEssentialLifeProtectPlusProductSelection = ({
  getSelectedProductLifeProtectPlus,
  selectProductLifeProtectPlus,
}) => {
  const productComboHealthEssentialLifeProtectPlus = [
    {
      text: '19 ปี',
      value: VALUES.COMBO_HEALTH_ESSENTIAL_LIFEPROTECT_PLUS_CODE.WLF19H,
    },
    {
      text: 'ถึงอายุ 99 ปี',
      value: VALUES.COMBO_HEALTH_ESSENTIAL_LIFEPROTECT_PLUS_CODE.WLF99H,
    },
  ]

  return (
    <div className="form-group">
      <div className="form-group-title">
        <span className="form-group-title-text">ระยะเวลาการชำระเบี้ยประกัน</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="value"
        className="model-factor"
        onChange={selectProductLifeProtectPlus}
        value={getSelectedProductLifeProtectPlus}
        options={productComboHealthEssentialLifeProtectPlus}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  getSelectedProductLifeProtectPlus: getSelectedProductLifeProtectPlus(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectProductLifeProtectPlus: bindActionCreators(selectProductLifeProtectPlus, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(ComboHealthEssentialLifeProtectPlusProductSelection)
